import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Col, Form, Input, Row} from 'antd'
import PermissionSelector from "../shared/permission-selector/PermissionSelector";


const GroupForm = ({selectedGroupInputs, viewMode, isNew, id, onChangeInput, searchedPermissions, selectedPermissions}) => {
    const permissionChangeHandler = (selectedPermissions) => {
        onChangeInput({
            target: {
                name: 'selectedPermissions',
                value: selectedPermissions
            },
        });
    }

    return (
        <Row gutter={[12, 0]}>
            <Col span={10}>
                <Form.Item label="Name" labelCol={{ span: 24 }}>
                    <Input name="name" type="text" placeholder="Name" size="large" onChange={onChangeInput} value={selectedGroupInputs.name} disabled={viewMode} />
                </Form.Item>
            </Col>
            <Col span={10}>
                <Form.Item label="Description" labelCol={{ span: 24 }}>
                    <Input name="description" type="text" placeholder="Last name" size="large" onChange={onChangeInput} value={selectedGroupInputs.description} disabled={viewMode} />
                </Form.Item>
            </Col>
            <Col span={20}>
                <Form.Item label="Permissions" labelCol={{ span: 24 }}>
                    <PermissionSelector
                        viewMode={viewMode}
                        onChange={permissionChangeHandler}
                        searchedPermissions={searchedPermissions}
                        selectedPermissions={selectedPermissions}
                    />
                </Form.Item>
            </Col>
        </Row>
    )
}

GroupForm.propTypes = {
    onChangeInput: PropTypes.func,
    selectedGroupInputs: PropTypes.object,
    viewMode: PropTypes.bool,
    isNew: PropTypes.bool,
}

GroupForm.defaultProps = {
    viewMode: false,
    isNew: false,
}

const mapStateToProps = ({ permissionsState, groupsState }) => {
    return {
        selectedGroupInputs: groupsState.selectedGroupInputs,
        searchedPermissions: permissionsState.searchedPermissions,
        selectedPermissions: groupsState.selectedGroupInputs.selectedPermissions,
    }
}

export default connect(mapStateToProps)(GroupForm)
